export const mascaraCep = (valor: string) => {
    // 00000-000
    const valorLimpo = valor.replace(/\D/g, '');
    return valorLimpo.replace(/(\d{5})(\d)/, '$1-$2');
};
